module.exports = __webpack_public_path__ + "img/024-brainstorm.c1040505.svg";